// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8813":"18fd4cb6","9351":"82abfe83"}[chunkId] + ".chunk.css";
};